<template>
  <Modal :width="650" :title="$t('seller.upload.purchase.retention.title')"
         :close-on-click-outside="false"
         @close="closeNoticeModal">
    <template v-slot:body>
      <form class="modal-content">
        <div class="form_item text_left">
          <span>{{
				  retentionCheck.isRetentionMandatory ? $t("seller.upload.retention.mandatory.description") : $t("seller.upload.retention.optional.description", {
					  currency: currency,
					  retentionAmountThreshold: retentionAmountThresholdFormatted,
					  retentionInPercent: retentionInPercentFormatted
				  })
			  }}</span>

          <div class="checkbox">
            <md-checkbox v-model="form.agreedToTerms"></md-checkbox>
            <span v-html="$t('seller.upload.retention.check.termsOfService', {url: retentionCheck.termsAndConditionsUrl })"></span>
          </div>

        </div>
      </form>
      <div class="flex flex_between margin_r">
        <md-button class="md-blank" @click="closeNoticeModal">{{ $t("common.button.back") }}</md-button>
        <div>
          <md-button class="md-blank margin_r" @click="submit(false)">{{ $t("seller.upload.purchase.retention.dontAllow") }}</md-button>
          <md-button class="opacity_5" :class="{ 'md-primary': isFormValid }" @click="submit(true)">{{ $t("seller.upload.purchase.retention.allow") }}</md-button>
        </div>
      </div>
    </template>
  </Modal>
</template>
<script>
import Modal from "@/components/templates/modal/Modal";
import {validateForm} from "@/validation/validation";
import {formatAsMoneyAmount, formatAsPercentage} from "@/common/format";

export default {
  components: {
    Modal
  },
	props: {
    	currency: String,
		retentionCheck: Object
	},
  computed: {
    isFormValid() {
      return this.form.agreedToTerms;
    },
	retentionAmountThresholdFormatted() {
      return formatAsMoneyAmount(this.retentionCheck.retentionAmountThreshold, { currency: this.currency, decimals: 0 });
    },
	retentionInPercentFormatted() {
      return formatAsPercentage(this.retentionCheck.retentionRate, { decimals: 0 });
    }

  },
  data() {
    return {
      form: {agreedToTerms: false},
    };
  },
  methods: {
    closeNoticeModal() {
      this.$emit("close");
    },
    submit(isRetentionAllowed = false) {
      validateForm(this, this.$validator)
          .then(() => {
	          this.$emit("confirm", isRetentionAllowed);
          })
          .catch(e => this.toast(e));
    },
  }
};
</script>
<style lang="scss" scoped>

.form_item {
  padding: 0 10px;
}

.btn_title {
  margin: 2rem 0;
}

.checkbox {
  display: flex;
  padding: 50px;
  align-items: self-end;
}

</style>
